import React, { Fragment } from 'react';
import PortrSDK from 'portr-javascript-sdk';
// child components
import PreSlotCompleteMsg from 'src/components/pre-slot-complete-message/pre-slot-complete-message.component';
// product service
import BookingProductService from '../../services/booking-product.service';
// globals
import { SEND_OTP_TO_USER, VERIFY_USER_OTP, SOTRE_PRE_ARRIVAL_DATA } from '../../globals';
// styles
const styles = require('./pre-slot-arrival.scss');
// images
const brandTick = require('../../images/brandTick.svg');
import deleteIcon from './../../images/delete.svg';
import tickIcon from './../../images/tick-blue.svg';
import MiniLoader from 'src/loaders/mini-loader';
// animations
const animationData = require('./lottie-animation.json');

const portrSDK = new PortrSDK();
const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
  'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY
};

declare var exponea: any;
interface ITrackingDataRequest {
  bookingReference?: string;
  bookingJourneyReference?: string;
  bookingEmail?: string;
  channel?: string;
}

interface IProps {
  trackingData: any;
  queryParams: any;
  apiKey: string;
  getData: Function;
  language: string;
  multiLang: any;
}

interface Passenger {
  id: number,
  value: string
  valid: boolean
}

interface BookingRef {
  id: number,
  value: string,
  valid: boolean,
  passengers: Passenger[],
}

interface IState {
  meetingPoint: any;
  lottieOptions: any;
  loaded: boolean;
  inputs: any;
  termSubStep: number;
  verificationOTP: number;
  invalidOTP: boolean;
  formValues: any;
  passangerValues: any;
  bookingRefs: BookingRef[],
  userGotOTP: boolean
  isOTPSubmitted: boolean
  isLoading: boolean;
  otpChannel: string;
  pendingOtpChannel: string;
  canSwitchChannel: boolean;
  switchChannelCountdown: number;
  mobileNumber: number;
  pnrAdded: boolean;
  isCustomsDeclarationSigned: boolean;
  isBookingEnteringDetails: boolean;
  isOTPVerifying: boolean;
  apiError: boolean;
  sendOTPToUserError: boolean,
  verifyOTPError: boolean
}

class PreSlotArrivalComponent extends React.Component<IProps, IState> {


  public bookingProductService = null;
  public switchChannelTimeout: any = null;
  public switchChannelInterval: any = null;
  public switchChannelCoolDown = 60;

  constructor(props: any) {
    super(props);
    this.state = {
      meetingPoint: props.trackingData.airportPreSlotTrackingStatus !== null
        ? props.trackingData.airportPreSlotTrackingStatus.airportPickUpCopy
        : null,
      lottieOptions: {
        animationData: animationData,
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      },
      loaded: false,
      inputs: ['input-0'],
      termSubStep: 1,
      verificationOTP: -1,
      invalidOTP: false,
      bookingRefs: [
        {
          id: 52452,
          value: '',
          valid: true,
          passengers: [
            {
              id: 12024,
              value: '',
              valid: true
            }
          ]
        }
      ],
      formValues: [{ id: 0 }],
      passangerValues: [{ id: 0 }],
      userGotOTP: true,
      isOTPSubmitted: false,
      isLoading: false,
      otpChannel: '',
      pendingOtpChannel: '',
      canSwitchChannel: false,
      switchChannelCountdown: this.switchChannelCoolDown,
      mobileNumber: props.trackingData.customerInfo.mobileNumber ? props.trackingData.customerInfo.mobileNumber : 123,
      // pnrAdded: true,
      pnrAdded: props.trackingData.customsDeclarationFlags.pnrAdded,
      // isCustomsDeclarationSigned: true,
      isCustomsDeclarationSigned: props.trackingData.customsDeclarationFlags.isCustomsDeclarationSigned,
      isBookingEnteringDetails: false,
      isOTPVerifying: false,
      apiError: false,
      sendOTPToUserError: false,
      verifyOTPError: false
    };
  }

  componentDidMount() {
    this.bookingProductService = new BookingProductService(this.props.trackingData.trackingBookingDetails, this.props.trackingData.collectionSlot);
    this.setState({ loaded: true });
    exponea.track('tracking_screen', { 'page_name': 'CustomDeclaration', 'product_type': 'ccd' });
  }

  componentWillUnmount() {
    clearTimeout(this.switchChannelTimeout);
    clearInterval(this.switchChannelInterval);
  }

  componentWillReceiveProps(props: IProps) {
    if (props.trackingData !== null) {
      this.setState({
        meetingPoint: props.trackingData.airportPreSlotTrackingStatus !== null
          ? props.trackingData.airportPreSlotTrackingStatus.airportPickUpCopy
          : null
      });
    }
  }

  meetingPointInfo() {
    const { language, multiLang } = this.props;
    return (
      <div className={styles.meetingPoint}>
        <h2>{multiLang[`whereDoIFindYou${language}`]}</h2>
        <p>{this.state.meetingPoint.intro}</p>
        <p className={styles.meetingPointLocation}>
          {this.state.meetingPoint.terminal}<br />
          {this.state.meetingPoint.areaLine1}<br />
          {this.state.meetingPoint.areaLine2}
        </p>
        <p>{this.state.meetingPoint.areaDetails}</p>
        <p><a className={styles.btnPrimary} href={this.state.meetingPoint.maplink} target='_blank'>{multiLang[`viewMapText${language}`]}</a></p>
      </div>
    )
  }

  // Add Booking Field to Form
  addFormFields() {
    const bookingId = Math.ceil(Math.random() * 1000 + 1000);
    const pId = Math.ceil(Math.random() * 1000 + 1000);
    this.setState({
      bookingRefs: [
        ...this.state.bookingRefs,
        {
          id: bookingId,
          value: '',
          valid: true,
          passengers: [
            {
              id: pId,
              value: '',
              valid: true
            }
          ]
        }
      ]
    })
  }
  // Remove dynamic created bookings
  removeFormFields(id) {
    const updatedBookingRefs = this.state.bookingRefs.filter((el, i) => {
      console.log(i, id);
      return el.id !== id
    });
    this.setState({ bookingRefs: [...updatedBookingRefs] });
  }

  // Add Passengers to Booking
  addPassangerFields(indexAt) {
    const id = Math.ceil(Math.random() * 1000 + 1000);

    const updatedBooking = this.state.bookingRefs.map((bookingRef, index) => {
      if (indexAt === index) {
        const updatedPassenger = {
          ...this.state.bookingRefs[indexAt],
          passengers: [
            ...this.state.bookingRefs[indexAt].passengers,
            {
              id: id,
              value: '',
              valid: true
            }
          ],
        };
        return updatedPassenger;
      }

      return bookingRef;
    })

    this.setState({
      bookingRefs: [
        ...updatedBooking
      ]
    })
  }

  // Remove Passenger from Booking
  removePassangerFields(bookingId, pid) {
    const selectedBooking = this.state.bookingRefs.filter((el, i) => {
      return el.id === bookingId
    });
    console.log(selectedBooking);
    const updatedBookingPassenger = selectedBooking[0].passengers.filter((pEl, i) => {
      return pEl.id !== pid;
    });
    console.log(updatedBookingPassenger);
    const updatedBooking = this.state.bookingRefs.map((booking, index) => {
      if (booking.id === bookingId) {
        const updatedPassenger = {
          ...selectedBooking[0],
          passengers: [
            ...updatedBookingPassenger,
          ],
        };
        return updatedPassenger;
      }

      return booking;
    })

    this.setState({ bookingRefs: [...updatedBooking] });
  }

  // booking value change handler
  bookingValueHandler(id, event) {
    const updatedBookingRefs = this.state.bookingRefs.map((el, i) => {
      if (el.id === id) {
        el.value = event.target.value;
        el.valid = true;
      }
      return el
    });
    this.setState({ bookingRefs: [...updatedBookingRefs] });
  }

  // passenger value change handler
  passengerValueHandler(bookingRef, id, event) {
    const selectedBooking = this.state.bookingRefs.filter((bEl, i) => {
      return bEl.id === bookingRef
    });
    const updatedBookingPassenger = selectedBooking[0].passengers.map((pEl, i) => {
      if (i === 0) {
        pEl.valid = true;
      }
      if (pEl.id === id) {
        pEl.value = event.target.value
      }
      return pEl;
    });

    const updatedBooking = this.state.bookingRefs.map((booking, index) => {
      if (booking.id === bookingRef) {
        const updatedPassenger = {
          ...selectedBooking[0],
          passengers: [
            ...updatedBookingPassenger,
          ],
        };
        return updatedPassenger;
      }
      return booking;
    })

    this.setState({ bookingRefs: [...updatedBooking] });
  }

  appendInput() {
    const newInput = `input-${this.state.inputs.length}`;
    this.setState(prevState => ({ inputs: prevState.inputs.concat([newInput]) }));
  }

  // Screen tracker
  termsNextStep(nextStep) {
    this.setState({ termSubStep: nextStep });
  }

  // Send OTP to customer
  sendOTPToUser(val) {
    const request: ITrackingDataRequest = {
      bookingReference: this.props.queryParams.bookingRef,
      bookingJourneyReference: this.props.trackingData.bookingJourneyReference,
      channel: val
    }
    this.setState({ isLoading: true, pendingOtpChannel: val });
    portrSDK.getTrackingDataWithHeader(
      API_PATH,
      SEND_OTP_TO_USER,
      'post',
      this.props.apiKey,
      request,
      header
    )
      .then((response) => {
        this.setState({ termSubStep: 2, isLoading: false, otpChannel: val, pendingOtpChannel: '' });
        this.startSwitchChannelCooldown();
      })
      .catch((err) => {
        this.setState({ isLoading: false, pendingOtpChannel: '', sendOTPToUserError: true });
        console.log(err)
      })
  }

  // Restart the cooldown that gates the "try other channel" switch button
  startSwitchChannelCooldown() {
    clearTimeout(this.switchChannelTimeout);
    clearInterval(this.switchChannelInterval);

    const cooldownSeconds = this.switchChannelCoolDown;
    this.setState({ canSwitchChannel: false, switchChannelCountdown: cooldownSeconds });

    this.switchChannelInterval = setInterval(() => {
      this.setState((prevState: IState) => ({ switchChannelCountdown: Math.max(prevState.switchChannelCountdown - 1, 0) }));
    }, 1000);

    this.switchChannelTimeout = setTimeout(() => {
      clearInterval(this.switchChannelInterval);
      this.setState({ canSwitchChannel: true, switchChannelCountdown: 0 });
    }, cooldownSeconds * 1000);
  }

  // did user got otp
  didUserGotOTP(check) {
    this.setState({ userGotOTP: check })
  }


  // Resend OTP using the currently selected channel
  reSendOTPToUser() {
    if (this.state.isOTPSubmitted) {
      this.setState({
        isOTPSubmitted: false,
        userGotOTP: true,
        invalidOTP: false,
      });
    }
    this.sendOTPToUser(this.state.otpChannel);
  }

  // Resend OTP using the other channel (e.g. switch from WhatsApp to SMS)
  switchOTPChannel() {
    if (this.state.isOTPSubmitted) {
      this.setState({
        isOTPSubmitted: false,
        userGotOTP: true,
        invalidOTP: false,
      });
    }
    const otherChannel = this.state.otpChannel === 'whatsapp' ? 'Sms' : 'whatsapp';
    this.sendOTPToUser(otherChannel);
  }

  // Get user OTP input
  getOTPUserInput(otp) {
    this.setState({ verificationOTP: otp });
  }
  enterDetailsHandler() {
    this.setState({ isBookingEnteringDetails: true })
  }
  // Verify OTP
  verifyOTP() {
    this.setState({ isOTPVerifying: true });
    const otp = this.state.verificationOTP + '';
    const request = {
      bookingReference: this.props.queryParams.bookingRef,
      bookingJourneyReference: this.props.trackingData.bookingJourneyReference,
      verificationCode: otp
    }
    if (otp.length === 5) {
      portrSDK.getTrackingDataWithHeader(
        API_PATH,
        VERIFY_USER_OTP,
        'post',
        this.props.apiKey,
        request,
        header
      )
        .then(res => {
          if (res.isSMSCodeVerified) {
            this.setState({
              isOTPSubmitted: true,
              isCustomsDeclarationSigned: true,
              isOTPVerifying: false,
            });
            this.props.getData();
          } else {
            this.setState({
              isOTPSubmitted: true,
              invalidOTP: true,
              termSubStep: -1,
              verificationOTP: -1,
              isOTPVerifying: false,
            });
          }
        })
        .catch(err => {
          this.setState({
            invalidOTP: true,
            termSubStep: -1,
            verificationOTP: -1,
            isOTPVerifying: false,
            verifyOTPError: true
          });
        })
    } else {
      this.setState({
        isOTPSubmitted: true,
        invalidOTP: true,
        termSubStep: -1,
        verificationOTP: -1,
        isOTPVerifying: false,
      });
    }
  }

  // Store PreArrival Booking Data
  storePreArrivalBookingData() {

    const preArrivalData = [];
    const validateData = [];
    let isValid = true;
    this.setState({ isLoading: true });
    for (let i = 0; i < this.state.bookingRefs.length; i++) {
      const bookingId = this.state.bookingRefs[i];
      let isBookingDataValid = true;
      let isPassengerDataValid = false;
      let ValidatePassenger = [];
      for (let j = 0; j < bookingId.passengers.length; j++) {
        const passenger = bookingId.passengers[j];
        const regex = /[^0-9!@#\$%\^\&*\)\(+=._-]{2,30}$/g;
        if (passenger.value.trim() !== '' && regex.test(passenger.value)) {
          isPassengerDataValid = true;
        }
        if (passenger.value.trim()) {
          preArrivalData.push({ name: passenger.value, pnr: bookingId.value })
        }
      }
      ValidatePassenger = bookingId.passengers.map((item, index) => {
        if (!isPassengerDataValid) {
          isValid = false;
          if (index === 0) {
            return { ...item, valid: false }
          }
        }
        return item
      });
      if (bookingId.value.trim() === '' || bookingId.value.length > 7) {
        isValid = false;
        isBookingDataValid = false;
        validateData.push({ ...bookingId, valid: false, passengers: [...ValidatePassenger] });
      } else {
        validateData.push({ ...bookingId, passengers: [...ValidatePassenger] });
      }
      console.log(isBookingDataValid, isPassengerDataValid)
    }
    this.setState({
      bookingRefs: [...validateData]
    });
    if (isValid) {
      const request = {
        bookingReference: this.props.queryParams.bookingRef,
        bookingJourneyReference: this.props.trackingData.bookingJourneyReference,
        preArrivalPassengers: preArrivalData
      };

      portrSDK.getTrackingDataWithHeader(
        API_PATH,
        SOTRE_PRE_ARRIVAL_DATA,
        'post',
        this.props.apiKey,
        request,
        header
      )
        .then(response => {
          this.setState({ isLoading: false })
          this.props.getData()
        })
        .catch(err => {
          this.setState({ isLoading: false, apiError: true })
          console.log(err);
        })
    } else {
      this.setState({ isLoading: false })
    }
  }
  // Render Booking Form
  renderBookingForm() {
    const { language, multiLang } = this.props;

    return (
      <React.Fragment>
        <p dangerouslySetInnerHTML={{ __html: multiLang[`enterDetailsText${language}`] }}></p>
        <div>
          {this.state.bookingRefs.map((element, index) => (
            <div className={styles.passengerBlock} key={index}>
              {index !== 0 ?
                <span className={styles.removePassengerBlock} onClick={() => this.removeFormFields(element.id)}><img src={deleteIcon} /></span>
                : null}
              <div className={styles.formGourp}>
                <label>{multiLang[`airlineBookingReferenceLabel${language}`]}</label>
                <span>{multiLang[`airlineBookingReferenceEX${language}`]}</span>
                <input type='text' placeholder={multiLang[`bookingReferenceLabel${language}`]} value={element.value} onChange={(e) => this.bookingValueHandler(element.id, e)} required />
                {!element.valid ? <p className={styles.error}>{multiLang[`errorMessageAirlineBookingReferenceRequired${language}`]}</p> : ''}
              </div>
              <div className={styles.formGourp + ' ' + styles.passengerField}>
                <label>{multiLang[`passengersUnderThisBookingText${language}`]}</label>
                {element.passengers.map((elementP, passangerIndex) => (
                  <div className={styles.passengerInput} key={passangerIndex}>
                    <input type='text' placeholder={multiLang[`nameOnPassportLabel${language}`]} value={elementP.value} onChange={(e) => this.passengerValueHandler(element.id, elementP.id, e)} required />
                    {passangerIndex !== 0
                      ? <span className={styles.removePassengerInput} onClick={() => this.removePassangerFields(element.id, elementP.id)}><img src={deleteIcon} /></span>
                      : ''}
                    {passangerIndex === 0 && !elementP.valid
                      ? <p className={styles.error}>{multiLang[`errorMessageBookingReferenceRequired${language}`]}</p>
                      : ''}
                  </div>
                ))}
              </div>
              <span className={styles.addPassenger} onClick={() => this.addPassangerFields(index)}>{multiLang[`addPassengerLabel${language}`]}</span>
            </div>
          ))}
          <span className={styles.addBookingRef} onClick={() => this.addFormFields()}>{multiLang[`addBookingReferenceLabel${language}`]}</span>
          <div className={styles.submitButton}>
            <button disabled={this.state.isLoading} onClick={() => this.storePreArrivalBookingData()} className={styles.btnPrimary}><span>{multiLang[`buttonSubmit${language}`]}&nbsp;{this.state.isLoading ? <MiniLoader /> : ''}</span></button>
          </div>
          {this.state.apiError ? <p className={styles.bottomError}>{multiLang[`errorMessageSomethingWentWrong${language}`]}</p> : null}
        </div>

      </React.Fragment>
    )
  }

  public render() {
    const { language, multiLang } = this.props;

    const isPnrAdded = this.props.trackingData.customsDeclarationFlags ? this.props.trackingData.customsDeclarationFlags.pnrAdded : false
    const isCustomsDeclarationSigned = this.state.isCustomsDeclarationSigned;
    // const { trackingData, queryParams } = this.props;
    // const { loaded, meetingPoint, lottieOptions } = this.state;
    const { loaded } = this.state;
    let afterVerification: any = '';
    // Declaration and AfterVerification
    if (isPnrAdded && isCustomsDeclarationSigned) {
      afterVerification = (
        <div className={styles.card}>
          <div className={styles.cardHeader}>{multiLang[`doneText${language}`]}</div>
          <img className={styles.centerImg} src={tickIcon} alt='' />
          <h2 className={styles.center}>{multiLang[`thanksText${language}`]}</h2>
          <div className={styles.cardBody}>
            <p>{multiLang[`bookingCompleteMessage${language}`]}</p>
          </div>
        </div>
      )
    }

    return (
      <Fragment>
        {loaded ?
          <div className={styles.mainContent}>
            <div className={styles.sectionWrapperContent}>
              <div className={styles.section}>
                {
                  isPnrAdded && isCustomsDeclarationSigned
                    ? afterVerification
                    : <>
                      <div className={styles.card}>
                        <div className={styles.cardHeader}>
                          <span>{isPnrAdded ? multiLang[`completeEDeclarationText${language}`] : multiLang[`enterPassengerDetailText${language}`]}</span>
                          <span>{isPnrAdded ? (<>{multiLang[`stepOutOf2Text${language}`].replace('%s', 2)} <img src={brandTick} alt='' /></>) : multiLang[`stepOutOf2Text${language}`].replace('%s', 1)}</span>
                        </div>
                        <div className={styles.cardBody}>
                          <p>
                            {multiLang[`thankYouBookingMessage${language}`]}
                          </p>
                          {isPnrAdded ?
                            <PreSlotCompleteMsg
                              language={language}
                              multiLang={multiLang}
                              currentStep={this.state.termSubStep}
                              isinvalidOTP={this.state.invalidOTP}
                              isUserVerified={isCustomsDeclarationSigned}
                              isPnrAdded={isPnrAdded}
                              termsNextStepClick={(n) => this.termsNextStep(n)}
                              sendOTPToUser={(val) => this.sendOTPToUser(val)}
                              getUserOTP={(n) => this.getOTPUserInput(n)}
                              verifyOTP={() => this.verifyOTP()}
                              reSendOTPToUser={() => this.reSendOTPToUser()}
                              switchOTPChannel={() => this.switchOTPChannel()}
                              otpChannel={this.state.otpChannel}
                              pendingOtpChannel={this.state.pendingOtpChannel}
                              canSwitchChannel={this.state.canSwitchChannel}
                              switchChannelCountdown={this.state.switchChannelCountdown}
                              userGotOTP={this.state.userGotOTP}
                              didUserGotOTP={(check) => this.didUserGotOTP(check)}
                              isOTPSubmitted={this.state.isOTPSubmitted}
                              isLoading={this.state.isLoading}
                              isOTPVerifying={this.state.isOTPVerifying}
                              userMobileNumber={this.state.mobileNumber}
                              verifyOTPError={this.state.verifyOTPError}
                              sendOTPToUserError={this.state.sendOTPToUserError}>
                            </PreSlotCompleteMsg>
                            : this.renderBookingForm()}
                        </div>
                      </div>
                    </>
                }
              </div>
            </div>
          </div>
          : null}
      </Fragment>
    );
  }

}

export default PreSlotArrivalComponent;



// WEBPACK FOOTER //
// ./src/containers/pre-slot-arrival/pre-slot-arrival.tsx